import * as angular from "angular";
import {IController} from "angular";

export class smsMessagesTableCtrl implements IController {

  range: any;
  referenceId: string;
  orderId: string;
  mobilePhone: any;
  infiniteScroll: any;

  constructor() {
  }

}

angular
  .module('bringoz.admin.messages')
  .component('smsMessagesTable', {
    bindings: {
      infiniteScroll: '<',
      isScrollable: '<?'
    },
    template: require('./sms-messages-table.html').default,
    controller: smsMessagesTableCtrl
  });
